import React from 'react';

import { Button, Checkbox, Spin } from 'antd';
import { SearchBar, Modal, List, Toast } from 'antd-mobile';

import styles from './selectformdata.module.css';

import { _refreshFieldValue } from "../../server";

const Item = List.Item;
const Brief = Item.Brief;

function closest(el, selector) {
    const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
    while (el) {
        if (matchesSelector.call(el, selector)) {
            return el;
        }
        el = el.parentElement;
    }
    return null;
}

class SelectSourceData extends React.Component {

    constructor(props) {
        super(props)
        this.sid = this.props.sid;

        this.state = {
            isLoading: true,
            modalVisible: false,
            formId: '',
            sourceDataList: [],
            originSourceDataList: [],
            selectedSourceData: [],
            reqParams: [],
            height: document.documentElement.clientHeight,
        };
    }

    componentDidMount() {
        this.props.triggerRef(this);
    }

    componentWillUnmount() {

    }

    onWrapTouchStart = (e) => {
        // fix touch to scroll background page on iOS
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
            return;
        }
        const pNode = closest(e.target, '.am-modal-content');
        if (!pNode) {
            e.preventDefault();
        }
    }

    async refreshFieldValue(formId, fieldId, reqParams) {
        const res = await _refreshFieldValue(this.sid, formId, fieldId, 0, reqParams);
        if (res.code === 0) {
            for (var i = 0; i < res.data.values.length; i++) {
                res.data.values[i].checked = false;
                for (var j = 0; j < this.state.selectedSourceData.length; j++) {
                    if (this.state.selectedSourceData[j] == res.data.values[i].name) {
                        res.data.values[i].checked = true;
                        break;
                    }
                }
            }
            var selectedSourceData = [];
            for (var i = 0; i < this.state.selectedSourceData.length; i++) {
                var isHas = false;
                for (var j = 0; j < res.data.values.length; j++) {
                    if (this.state.selectedSourceData[i] == res.data.values[j].name) {
                        isHas = true;
                        break;
                    }
                }
                if (isHas) {
                    selectedSourceData.push(this.state.selectedSourceData[i]);
                }
            }
            this.setState({
                isLoading: false,
                sourceDataList: res.data.values,
                originSourceDataList: [].concat(res.data.values),
                selectedSourceData: selectedSourceData,
            });
        }
    }

    goBack() {
        this.setState({ modalVisible: false, });
    }

    onFormDataSelect(checked, data) {
        var index = -1;
        for (var i = 0; i < this.state.selectedSourceData.length; i++) {
            if (this.state.selectedSourceData[i] == data.name) {
                index = i;
                break;
            }
        }
        if (checked) {
            if (index == -1) {
                this.state.selectedSourceData.push(data.name);
            }
        } else {
            if (index >= 0) {
                this.state.selectedSourceData.splice(index, 1);
            }
        }
        this.setState({ selectedSourceData: this.state.selectedSourceData, sourceDataList: this.state.sourceDataList });
    }

    handleOk = e => {
        if (!this.state.selectedSourceData || this.state.selectedSourceData.length == 0) {
            Toast.info("请选择数据", 1);
            return;
        }
        if (this.state.selectedSourceData.length > this.maxLength) {
            Toast.info("至多选择" + this.maxLength + " 条数据", 1);
            return;
        }
        var selectedData = []
        for (var i = 0; i < this.state.selectedSourceData.length; i++) {
            selectedData.push(this.state.selectedSourceData[i]);
        }
        this.props.callback(this.props.extra, selectedData);
        this.setState({ modalVisible: false, });
    }

    showModal = () => {
        this.pageIndex = 0;
        var selectedList = [];
        if (this.props.selectedData) {
            selectedList = [...this.props.selectedData];
        }

        var formId = this.props.extra.formId;
        var fieldId = this.props.extra.fieldId;
        var reqParams = this.props.extra.reqParams;
        this.setState({
            selectedSourceData: selectedList,
            modalVisible: true,
            formId: formId,
            searchKey: "",
            fieldId: fieldId,
            reqParams: reqParams,
            sourceDataList: [],
            originSourceDataList: []
        }, () => { this.refreshFieldValue(this.state.formId, this.state.fieldId, this.state.reqParams) });
        if (this.props.extra && this.props.extra.maxLength && this.props.extra.maxLength > 0) {
            this.maxLength = this.props.extra.maxLength;
        } else {
            this.maxLength = 30;
        }
    }

    render() {
        const view_listItem = this.state.sourceDataList.map((item, index) =>
            <Item key={index} style={{ paddingRight: 15, minHeight: 80 }}>
                <Checkbox style={{ fontSize: 16, display: 'block', width: '100%', textOverflow: "ellipsis", whiteSpace: "normal", wordWrap: "break-word" }} defaultChecked={item.checked} onChange={(e) => this.onFormDataSelect(e.target.checked, item)}>
                    {item.name}
                </Checkbox>
            </Item>
        );

        return <Modal wrapProps={{ onTouchStart: this.onWrapTouchStart }} visible={this.state.modalVisible} animationType="slide-up">
            <div className={styles.searchBar}>
                <SearchBar className={styles.searchInputWrap} placeholder="搜索" maxLength={20}
                    onChange={
                        (value) => {
                            if (value) {
                                let tmpArray = [];
                                this.state.originSourceDataList.map((item) => {
                                    if (item.name.toUpperCase().indexOf(value.toUpperCase()) >= 0) {
                                        tmpArray.splice(tmpArray.length, 0, item);
                                    }
                                })
                                this.setState({ sourceDataList: tmpArray });
                            } else {
                                this.setState({ sourceDataList: this.state.originSourceDataList });
                            }
                        }
                    } />
            </div>
            {
                this.state.isLoading ? <Spin style={{ width: "100%", marginTop: "40%" }} size="large" /> :
                    <List style={{ height: this.state.height - 166 }} renderFooter={() => (<div style={{ padding: 0, textAlign: 'center', marginBottom: 60 }}>{this.state.isLoading ? '加载中...' : this.state.sourceDataList.length > 0 ? '共' + this.state.sourceDataList.length + '条数据' : ""}</div>)}>
                        {this.state.sourceDataList.length > 0 ? view_listItem : <div className="empty"><div className="img"></div><p className="desc">暂无数据</p></div>}
                    </List>
            }
            <div className={styles.userOrDeptSelectFooter}>
                <div className={styles.buttonGroup}>
                    <Button style={{ flex: 1, height: 44, marginRight: 15 }} onClick={() => this.goBack()}>取消</Button>
                    <Button style={{ flex: 1, height: 44 }} type="primary" onClick={() => this.handleOk()}>{this.state.selectedSourceData.length > 0 ? <span>选择{this.state.selectedSourceData.length}条</span> : <span>确认</span>}</Button>
                </div>
            </div>
        </Modal>
    }

}

export default SelectSourceData;